import React from "react";
import { ApplicationWidgetPanelTemplate } from "themes/common/components";

function ApplicationWidgetPanel(props) {
    return <ApplicationWidgetPanelTemplate {...props} />;
}

export default ApplicationWidgetPanel;
